import '../tables/neb-table';
import '../neb-popup-header';
import { html, css } from 'lit';

import { CSS_SPACING } from '../../../../neb-styles/neb-variables';
import { parseDate } from '../../../../neb-utils/date-util';

import Overlay from './neb-overlay';

export const ELEMENTS = {
  header: {
    id: 'recent-banners-header',
  },
  recentBanners: {
    id: 'recent-banners',
  },
};

const RECENT_BANNERS_TABLE_CONFIG = [
  {
    key: 'messageType',
    label: 'Banner Type',
    flex: css`0 1 100px`,
    formatter: v => v.charAt(0).toUpperCase() + v.slice(1),
  },
  {
    key: 'message',
    label: 'Message',
    flex: css`1 0 0`,
    formatter: v => (v.endsWith('.') ? v : `${v}.`),
  },
  {
    key: 'eventTime',
    label: 'Event Time',
    flex: css`1 0 0`,
    formatter: v => parseDate(v).format('MM/DD/YYYY hh:mm:ss A'),
  },
];

class NebOverlayRecentBanners extends Overlay {
  static get properties() {
    return {};
  }

  initState() {
    super.initState();
    this.__recentBannerKey = this.getRecentBannerKey();
    this.__recentBanners = this.getRecentBanners();
  }

  initHandlers() {
    super.initHandlers();
    this.handlers = {
      ...this.handlers,
      closeAll: () => this.handlers.dismiss(true),
      delete: () => {
        localStorage.removeItem(this.__recentBannerKey);
        this.__recentBanners = [];
        this.requestUpdate();
      },
    };
  }

  getRecentBannerKey() {
    const { tenantId, idToken: { payload: { sub: userId } = {} } = {} } =
      JSON.parse(localStorage.getItem('neb-login-local'));
    return `recentBanners:${tenantId}:${userId}`;
  }

  getRecentBanners() {
    const recentBanners =
      JSON.parse(localStorage.getItem(this.__recentBannerKey)) || [];
    return recentBanners.sort((a, b) => b.eventTime.localeCompare(a.eventTime));
  }

  showEmptyMessage() {
    return this.__recentBanners.length ? '' : 'There are no recent banners';
  }

  static get styles() {
    return [
      super.styles,
      css`
        .header {
          padding: ${CSS_SPACING};
        }

        .content {
          width: 700px;
          overflow: auto;
        }

        .caption {
          padding: 0 ${CSS_SPACING};
        }

        .cell-header {
          text-align: center;
        }

        .table {
          overflow: auto;
        }
      `,
    ];
  }

  renderContent() {
    return html`
      <neb-popup-header
        id="${ELEMENTS.header.id}"
        class="header"
        title="Recent Banners"
        subTitle="View your most recent 50 banners."
        .onBack="${this.handlers.dismiss}"
        .onCancel="${this.handlers.closeAll}"
        .onDelete="${this.handlers.delete}"
        ?showBackButton="${this.index}"
        showDeleteButton
      ></neb-popup-header>

      <neb-table
        id="${ELEMENTS.recentBanners.id}"
        class="table"
        .emptyMessage="${this.showEmptyMessage()}"
        .config="${RECENT_BANNERS_TABLE_CONFIG}"
        .model="${this.__recentBanners}"
      ></neb-table>
    `;
  }
}

customElements.define('neb-overlay-recent-banners', NebOverlayRecentBanners);
